import { useState } from "react";
import { useChangeEmailMutation } from "entities/user";
import { getChangeEmailError } from "./getEmailChangeErrors";
import { validateEmail } from "./validateEmail";

interface UseChangeEmailResult {
  email: string;
  setEmail: (value: string) => void;
  submit: () => void;
  isSubmitting: boolean;
  error: string | null;
  // Адрес, на который ушло письмо; null — пока запрос не выполнен.
  pendingEmail: string | null;
}

export const useChangeEmail = (
  currentEmail: string | null,
): UseChangeEmailResult => {
  const [email, setEmailValue] = useState("");
  const [validationError, setValidationError] = useState<string | null>(null);
  const [changeEmail, { isLoading, error, data, reset }] =
    useChangeEmailMutation();

  const setEmail = (value: string) => {
    setEmailValue(value);
    setValidationError(null);
    reset();
  };

  const submit = () => {
    const trimmed = email.trim();
    const nextError = validateEmail(trimmed, currentEmail);
    setValidationError(nextError);
    if (!nextError) changeEmail({ email: trimmed });
  };

  return {
    email,
    setEmail,
    submit,
    isSubmitting: isLoading,
    error: validationError ?? getChangeEmailError(error),
    pendingEmail: data?.pending_email ?? null,
  };
};
